/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* `httpResource` is still an experimental feature - NOT PRODUCTION READY
* Generated Angular service for CallStatisticResource
* Do not edit this file manually
*/
import { HttpContext, HttpContextToken, HttpHeaders, HttpParams, httpResource, HttpResourceOptions, HttpResourceRef, HttpResourceRequest } from "@angular/common/http";
import { inject, Injectable, Signal } from "@angular/core";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { GetLiveCallStatisticsResponse, GetCallStatisticsResponse } from "../models";

@Injectable({ providedIn: "root" })
export class CallStatisticResource {
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getLiveCallStatistics(resourceOptions: HttpResourceOptions<GetLiveCallStatisticsResponse, unknown> & { defaultValue: NoInfer<GetLiveCallStatisticsResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetLiveCallStatisticsResponse>;
    getLiveCallStatistics(resourceOptions?: HttpResourceOptions<GetLiveCallStatisticsResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetLiveCallStatisticsResponse | undefined>;
    getLiveCallStatistics(resourceOptions?: HttpResourceOptions<GetLiveCallStatisticsResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetLiveCallStatisticsResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/CallStatistic/live`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getCallStatistics(startDate: Signal<Date> | Date, endDate: Signal<Date> | Date, resourceOptions: HttpResourceOptions<GetCallStatisticsResponse, unknown> & { defaultValue: NoInfer<GetCallStatisticsResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCallStatisticsResponse>;
    getCallStatistics(startDate: Signal<Date> | Date, endDate: Signal<Date> | Date, resourceOptions?: HttpResourceOptions<GetCallStatisticsResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCallStatisticsResponse | undefined>;
    getCallStatistics(startDate: Signal<Date> | Date, endDate: Signal<Date> | Date, resourceOptions?: HttpResourceOptions<GetCallStatisticsResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCallStatisticsResponse | undefined> {
        return httpResource(() => {
            let params = new HttpParams();
            const startDateValue = typeof startDate === 'function' ? startDate() : startDate;
            if (startDateValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, startDateValue, 'startDate');
            }
            const endDateValue = typeof endDate === 'function' ? endDate() : endDate;
            if (endDateValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, endDateValue, 'endDate');
            }
            return {
                url: `${this.basePath}/CallStatistic`,
                method: "GET",
                params,
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }
}
